import { lazy } from 'react'

import Valori from './valori'

export default {
    path: '/parametri',
    title: 'Parametri',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:parametroId',
            title: 'Parametro: {{params.parametroId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Valori]
        }
    ]
}